"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateSelector = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var luxon_1 = require("luxon");
var faChevronLeft_1 = require("@fortawesome/pro-regular-svg-icons/faChevronLeft");
var faChevronRight_1 = require("@fortawesome/pro-regular-svg-icons/faChevronRight");
var faChevronDoubleLeft_1 = require("@fortawesome/pro-regular-svg-icons/faChevronDoubleLeft");
var faChevronDoubleRight_1 = require("@fortawesome/pro-regular-svg-icons/faChevronDoubleRight");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var utils_1 = require("utils");
var DATE_STYLES = "flex transition duration-100 ease-out mb-1 ml-1 text-xs";
var DESELECTED_DATE_STYLES = "bg-gray-100 hover:bg-gray-300";
var SELECTED_DATE_STYLES = "bg-primary text-white";
var DATE_NAV_STYLES = "flex bg-white rounded px-2";
var TITLE_STYLES = "text-sm font-semibold flex-grow text-center m-auto";
var WEEK_STYLES = "grid grid-cols-7";
var IN_MONTH_STYLES = "text-gray-800";
var OUT_OF_MONTH_STYLES = "text-gray-400";
var BUTTON_STYLES = "p-1";
var DateSelector = function (_a) {
    var initialDate = _a.initialDate, selectedDate = _a.selectedDate, handleSelectedDate = _a.onDateSelected, _b = _a.dateFormat, dateFormat = _b === void 0 ? "yyyy-MM-dd" : _b, useFormattedValue = _a.useFormattedValue;
    var _c = (0, react_1.useState)(0), increment = _c[0], setIncrement = _c[1];
    var handleIncrementClick = function (newIncrement) { return function (e) {
        e.preventDefault();
        e.stopPropagation();
        setIncrement(increment + newIncrement);
    }; };
    var initializedDate = (0, react_1.useRef)({ selectedDate: selectedDate, initialDate: initialDate });
    (0, react_1.useEffect)(function () {
        if (initializedDate.current.selectedDate === selectedDate &&
            initializedDate.current.initialDate === initialDate) {
            return;
        }
        setIncrement(0);
    }, [selectedDate, initialDate, setIncrement]);
    var anchorDate = selectedDate !== null && selectedDate !== void 0 ? selectedDate : initialDate;
    var parsedDate = anchorDate
        ? useFormattedValue
            ? luxon_1.DateTime.fromFormat(anchorDate, dateFormat, { zone: "utc" })
            : luxon_1.DateTime.fromISO(anchorDate, { zone: "utc" })
        : luxon_1.DateTime.fromJSDate(new Date(), { zone: "utc" });
    var originDate = parsedDate.isValid
        ? parsedDate
        : luxon_1.DateTime.fromJSDate(new Date(), { zone: "utc" });
    var monthStart = originDate.startOf("month").plus({ months: increment });
    var handleDateClick = function (date) { return function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (handleSelectedDate) {
            handleSelectedDate(date);
        }
    }; };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "h-full w-full px-1" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col" }, { children: [(0, jsx_runtime_1.jsxs)("nav", __assign({ className: DATE_NAV_STYLES }, { children: [(0, jsx_runtime_1.jsx)("button", __assign({ onClick: handleIncrementClick(-12), className: BUTTON_STYLES }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faChevronDoubleLeft_1.faChevronDoubleLeft }, void 0) }), void 0), (0, jsx_runtime_1.jsx)("h3", __assign({ className: TITLE_STYLES }, { children: monthStart.toFormat("yyyy") }), void 0), (0, jsx_runtime_1.jsx)("button", __assign({ onClick: handleIncrementClick(12), className: BUTTON_STYLES }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faChevronDoubleRight_1.faChevronDoubleRight }, void 0) }), void 0)] }), void 0), (0, jsx_runtime_1.jsxs)("nav", __assign({ className: (0, utils_1.concatStyles)([DATE_NAV_STYLES, "mb-2"]) }, { children: [(0, jsx_runtime_1.jsx)("button", __assign({ onClick: handleIncrementClick(-1), className: BUTTON_STYLES }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faChevronLeft_1.faChevronLeft }, void 0) }), void 0), (0, jsx_runtime_1.jsx)("h3", __assign({ className: TITLE_STYLES }, { children: monthStart.toFormat("MMM") }), void 0), (0, jsx_runtime_1.jsx)("button", __assign({ onClick: handleIncrementClick(1), className: BUTTON_STYLES }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faChevronRight_1.faChevronRight }, void 0) }), void 0)] }), void 0), new Array(6).fill("").map(function (_, weeks) {
                    var start = luxon_1.DateTime.fromISO(monthStart.toISODate(), {
                        zone: "utc",
                    })
                        .plus({ weeks: weeks })
                        .startOf("week");
                    return ((0, jsx_runtime_1.jsx)("ul", __assign({ className: WEEK_STYLES }, { children: new Array(7).fill("").map(function (_, days) {
                            var day = luxon_1.DateTime.fromISO(start.toISODate(), {
                                zone: "utc",
                            }).plus({ days: days });
                            var inMonth = monthStart.month === day.month;
                            var selected = day.diff(originDate, "day").days === 0;
                            return ((0, jsx_runtime_1.jsx)("li", __assign({ className: (0, utils_1.concatStyles)([
                                    DATE_STYLES,
                                    selected ? SELECTED_DATE_STYLES : DESELECTED_DATE_STYLES,
                                    inMonth ? IN_MONTH_STYLES : OUT_OF_MONTH_STYLES,
                                ]) }, { children: (0, jsx_runtime_1.jsx)("button", __assign({ className: (0, utils_1.concatStyles)([
                                        "flex flex-grow p-1",
                                        selected ? "text-white" : null,
                                    ]), onClick: handleDateClick(day.toFormat(dateFormat)) }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "m-auto" }, { children: day.toFormat("d") }), void 0) }), void 0) }), weeks + "-" + days));
                        }) }), "minical-week-" + weeks));
                })] }), void 0) }), void 0));
};
exports.DateSelector = DateSelector;
exports.DateSelector.displayName = "Form.DateSelector";
